// import { useEffect, useState } from "react";
// import { message, Spin } from "antd";
// import { fetchRoleAccess, saveRoleAccess } from "../Service/Useraccessservice";

// // ─── Menu hierarchy (mirrors homepage.js sidebar) ────────────────────────────
// const MENU_TREE = [
//   {
//     key: "CHECKLIST_BUILDER",
//     label: "Checklist Builder",
//     icon: "☑",
//     iconBg: "#E6F1FB",
//     children: [
//       { key: "CHECKLIST", label: "Checklist" },
//       {
//         key: "CHECKLIST_CONFIG",
//         label: "Configuration",
//         children: [
//           { key: "CHECKLIST_TEMPLATE", label: "Templates" },
//           { key: "CHECKLIST_BINDING", label: "Binding" },
//         ],
//       },
//     ],
//   },
//   {
//     key: "QUALITY_PLAN",
//     label: "Quality Plan",
//     icon: "◎",
//     iconBg: "#E1F5EE",
//     children: [
//       { key: "QUALITY_EXECUTION", label: "Execution" },
//       {
//         key: "QUALITY_CONFIG",
//         label: "Configuration",
//         children: [
//           { key: "QUALITY_COMPORT", label: "Comport Settings" },
//           { key: "QUALITY_DEVICE", label: "Device Settings" },
//           { key: "QUALITY_TEMPLATE", label: "Templates" },
//         ],
//       },
//     ],
//   },
//   {
//     key: "AMS",
//     label: "Asset Monitoring System",
//     icon: "⬡",
//     iconBg: "#FAF0E6",
//     children: [
//       { key: "AMS_LIVE_MONITORING", label: "Live Monitoring" },
//       { key: "AMS_NOTIFICATIONS", label: "Notifications" },
//     ],
//   },
//   {
//     key: "CONFIGURATION",
//     label: "Configuration",
//     icon: "⚙",
//     iconBg: "#F1EFE8",
//     children: [
//       { key: "CONFIG_ORGANIZATION", label: "Organization" },
//       { key: "CONFIG_PRODUCT", label: "Product" },
//       { key: "CONFIG_IOT_GATEWAY", label: "IoT Gateway" },
//       { key: "CONFIG_MACHINE", label: "Machine" },
//       { key: "CONFIG_ROLE", label: "Role" },
//       { key: "CONFIG_USER", label: "User" },
//     ],
//   },
// ];

// const ACTIONS = ["read", "create", "update", "delete"];

// // ─── Helpers ─────────────────────────────────────────────────────────────────

// /** Collect every key in the tree recursively */
// const collectAllKeys = (nodes) =>
//   nodes.flatMap((n) => [n.key, ...(n.children ? collectAllKeys(n.children) : [])]);

// /** Build initial flat permissions map from API data */
// const buildPermMap = (apiList) => {
//   const map = {};
//   (apiList || []).forEach(({ menuKey, canRead, canCreate, canUpdate, canDelete }) => {
//     map[menuKey] = { read: canRead, create: canCreate, update: canUpdate, delete: canDelete };
//   });
//   return map;
// };

// /** Default empty permission object */
// const emptyPerm = () => ({ read: false, create: false, update: false, delete: false });

// /** Get or create perms for a key */
// const getPerms = (map, key) => map[key] || emptyPerm();

// /** Cascade: when a parent perm changes, force children to comply */
// const cascadeDown = (map, nodes, parentPerms) => {
//   let next = { ...map };
//   nodes.forEach((node) => {
//     const cur = getPerms(next, node.key);
//     const effective = {
//       read: parentPerms.read && cur.read,
//       create: parentPerms.read && parentPerms.create && cur.read && cur.create,
//       update: parentPerms.read && parentPerms.update && cur.read && cur.update,
//       delete: parentPerms.read && parentPerms.delete && cur.read && cur.delete,
//     };
//     next[node.key] = effective;
//     if (node.children) {
//       next = cascadeDown(next, node.children, effective);
//     }
//   });
//   return next;
// };

// /** Toggle one action on one key */
// const togglePerm = (map, nodes, targetKey, action) => {
//   let next = { ...map };

//   const visit = (nodeList, parentPerms) => {
//     nodeList.forEach((node) => {
//       if (node.key === targetKey) {
//         const cur = getPerms(next, node.key);
//         const newVal = !cur[action];
//         let updated = { ...cur };

//         if (action === "read" && !newVal) {
//           updated = emptyPerm(); // turning off read clears everything
//         } else {
//           updated[action] = newVal;
//         }

//         next[node.key] = updated;

//         // Cascade down to children
//         if (node.children) {
//           next = cascadeDown(next, node.children, updated);
//         }
//       } else {
//         if (node.children) {
//           visit(node.children, getPerms(next, node.key));
//         }
//       }
//     });
//   };

//   visit(nodes, { read: true, create: true, update: true, delete: true });
//   return next;
// };

// /** Check if a given action toggle should be disabled */
// const isDisabled = (permMap, node, action, parentKey) => {
//   if (!parentKey) return false;
//   const parentPerm = getPerms(permMap, parentKey);
//   if (!parentPerm.read) return true;
//   if (action !== "read" && !getPerms(permMap, node.key).read) return true;
//   return !parentPerm[action];
// };

// // ─── Toggle component ─────────────────────────────────────────────────────────
// const Toggle = ({ on, disabled, onChange }) => (
//   <button
//     onClick={onChange}
//     disabled={disabled}
//     style={{
//       width: 36,
//       height: 20,
//       borderRadius: 10,
//       border: "none",
//       cursor: disabled ? "not-allowed" : "pointer",
//       position: "relative",
//       background: disabled ? "#EFEFEF" : on ? "#1D9E75" : "#D3D1C7",
//       opacity: disabled ? 0.5 : 1,
//       transition: "background 0.15s",
//       flexShrink: 0,
//     }}
//   >
//     <span
//       style={{
//         position: "absolute",
//         top: 3,
//         left: on && !disabled ? 19 : 3,
//         width: 14,
//         height: 14,
//         borderRadius: "50%",
//         background: "white",
//         transition: "left 0.15s",
//         display: "block",
//       }}
//     />
//   </button>
// );

// // ─── Permission row ───────────────────────────────────────────────────────────
// const PermRow = ({ node, permMap, parentKey, onToggle, level }) => {
//   const perms = getPerms(permMap, node.key);
//   const paddingLeft = 16 + level * 24;

//   return (
//     <>
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "1fr 70px 70px 70px 70px",
//           alignItems: "center",
//           padding: `9px 12px 9px ${paddingLeft}px`,
//           borderTop: "0.5px solid #e8e8e8",
//           background: level === 0 ? "#fafaf9" : "transparent",
//           transition: "background 0.1s",
//         }}
//       >
//         <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
//           {level > 0 && (
//             <span
//               style={{
//                 width: 5,
//                 height: 5,
//                 borderRadius: "50%",
//                 background: "#d0d0d0",
//                 flexShrink: 0,
//               }}
//             />
//           )}
//           <span
//             style={{
//               fontSize: 13,
//               fontWeight: level === 0 ? 500 : 400,
//               color: "#1a1a1a",
//             }}
//           >
//             {node.label}
//           </span>
//         </div>

//         {ACTIONS.map((action) => (
//           <div key={action} style={{ display: "flex", justifyContent: "center" }}>
//             <Toggle
//               on={perms[action]}
//               disabled={isDisabled(permMap, node, action, parentKey)}
//               onChange={() => onToggle(node.key, action)}
//             />
//           </div>
//         ))}
//       </div>

//       {node.children?.map((child) => (
//         <PermRow
//           key={child.key}
//           node={child}
//           permMap={permMap}
//           parentKey={node.key}
//           onToggle={onToggle}
//           level={level + 1}
//         />
//       ))}
//     </>
//   );
// };

// // ─── Module card ──────────────────────────────────────────────────────────────
// const ModuleCard = ({ module, permMap, onToggle }) => {
//   const [open, setOpen] = useState(false);
//   const rootPerm = getPerms(permMap, module.key);
//   const activeCount = ACTIONS.filter((a) => rootPerm[a]).length;

//   return (
//     <div
//       style={{
//         background: "#ffffff",
//         border: "0.5px solid #e5e5e5",
//         borderRadius: 10,
//         marginBottom: 10,
//         overflow: "hidden",
//       }}
//     >
//       {/* Card header — clicking opens the permission rows */}
//       <div
//         onClick={() => setOpen((v) => !v)}
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           padding: "12px 14px",
//           cursor: "pointer",
//           background: open ? "#fafaf9" : "#ffffff",
//           transition: "background 0.1s",
//         }}
//       >
//         <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//           <div
//             style={{
//               width: 30,
//               height: 30,
//               borderRadius: 7,
//               background: module.iconBg,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               fontSize: 14,
//             }}
//           >
//             {module.icon}
//           </div>
//           <div>
//             <div style={{ fontSize: 13, fontWeight: 500, color: "#1a1a1a" }}>
//               {module.label}
//             </div>
//             <div style={{ fontSize: 11, color: "#999", marginTop: 1 }}>
//               {activeCount} of 4 permissions active
//             </div>
//           </div>
//         </div>

//         <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//           {/* Mini badge summary */}
//           <div style={{ display: "flex", gap: 5 }}>
//             {ACTIONS.map((a) => (
//               <span
//                 key={a}
//                 style={{
//                   fontSize: 10,
//                   padding: "2px 7px",
//                   borderRadius: 4,
//                   fontWeight: 500,
//                   background: rootPerm[a] ? "#E1F5EE" : "#F1EFE8",
//                   color: rootPerm[a] ? "#0F6E56" : "#888780",
//                 }}
//               >
//                 {a.charAt(0).toUpperCase() + a.slice(1)}
//               </span>
//             ))}
//           </div>
//           <span
//             style={{
//               fontSize: 13,
//               color: "#bbb",
//               display: "inline-block",
//               transform: open ? "rotate(90deg)" : "rotate(0deg)",
//               transition: "transform 0.2s",
//             }}
//           >
//             ›
//           </span>
//         </div>
//       </div>

//       {/* Expanded rows */}
//       {open && (
//         <div style={{ borderTop: "0.5px solid #e8e8e8" }}>
//           {/* Column header */}
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "1fr 70px 70px 70px 70px",
//               padding: "7px 12px",
//               background: "#f5f5f3",
//             }}
//           >
//             <span style={{ fontSize: 11, fontWeight: 500, color: "#bbb", textTransform: "uppercase", letterSpacing: "0.05em" }}>
//               Module / Feature
//             </span>
//             {ACTIONS.map((a) => (
//               <span
//                 key={a}
//                 style={{
//                   fontSize: 11,
//                   fontWeight: 500,
//                   color: "#bbb",
//                   textTransform: "uppercase",
//                   letterSpacing: "0.05em",
//                   textAlign: "center",
//                 }}
//               >
//                 {a.charAt(0).toUpperCase() + a.slice(1)}
//               </span>
//             ))}
//           </div>

//           <PermRow
//             node={module}
//             permMap={permMap}
//             parentKey={null}
//             onToggle={onToggle}
//             level={0}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// // ─── Main form ────────────────────────────────────────────────────────────────
// const UserAccessForm = ({ role, onSaved }) => {
//   const [permMap, setPermMap] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();

//   // Load existing permissions for this role
//   useEffect(() => {
//     if (!role?.uuid) return;
//     setLoading(true);
//     fetchRoleAccess(role.uuid)
//       .then((res) => {
//         setPermMap(buildPermMap(res.data?.data || []));
//       })
//       .catch(() => messageApi.error("Failed to load permissions"))
//       .finally(() => setLoading(false));
//   }, [role?.uuid]);

//   const handleToggle = (key, action) => {
//     setPermMap((prev) => togglePerm(prev, MENU_TREE, key, action));
//   };

//   const handleReset = () => {
//     const allKeys = collectAllKeys(MENU_TREE);
//     const empty = {};
//     allKeys.forEach((k) => (empty[k] = emptyPerm()));
//     setPermMap(empty);
//   };

//   const handleSave = async () => {
//     setSaving(true);
//     try {
//       // Convert flat permMap back to API shape
//       const permissions = Object.entries(permMap).map(([menuKey, p]) => ({
//         menuKey,
//         canRead: p.read,
//         canCreate: p.create,
//         canUpdate: p.update,
//         canDelete: p.delete,
//       }));

//       await saveRoleAccess(role.uuid, permissions);
//       messageApi.success("Permissions saved successfully");
//       setTimeout(() => onSaved?.(), 800);
//     } catch {
//       messageApi.error("Failed to save permissions");
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <Spin spinning={loading || saving}>
//       {contextHolder}

//       <div style={{ maxHeight: "65vh", overflowY: "auto", paddingRight: 4 }}>
//         {MENU_TREE.map((module) => (
//           <ModuleCard
//             key={module.key}
//             module={module}
//             permMap={permMap}
//             onToggle={handleToggle}
//           />
//         ))}
//       </div>

//       {/* Action bar */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "flex-end",
//           gap: 10,
//           marginTop: 16,
//           paddingTop: 14,
//           borderTop: "0.5px solid #e8e8e8",
//         }}
//       >
//         <button
//           onClick={handleReset}
//           style={{
//             padding: "7px 18px",
//             borderRadius: 7,
//             fontSize: 13,
//             fontWeight: 500,
//             cursor: "pointer",
//             border: "0.5px solid #ccc",
//             background: "#fff",
//             color: "#333",
//           }}
//         >
//           Reset
//         </button>
//         <button
//           onClick={handleSave}
//           disabled={saving}
//           style={{
//             padding: "7px 18px",
//             borderRadius: 7,
//             fontSize: 13,
//             fontWeight: 500,
//             cursor: saving ? "not-allowed" : "pointer",
//             border: "none",
//             background: "#1D9E75",
//             color: "white",
//             opacity: saving ? 0.7 : 1,
//           }}
//         >
//           {saving ? "Saving…" : "Save changes"}
//         </button>
//       </div>
//     </Spin>
//   );
// };

// export default UserAccessForm;

import { useEffect, useState } from "react";
import { message, Spin } from "antd";
import { fetchRoleAccess, saveRoleAccess } from "../Service/Useraccessservice";

// ─── Menu hierarchy (must mirror menuConfig.js sidebar exactly) ──────────────
const MENU_TREE = [
  {
    key: "CHECKLIST_BUILDER",
    label: "Checklist Builder",
    icon: "☑",
    iconBg: "#E6F1FB",
    children: [
      { key: "CHECKLIST", label: "Checklist" },
      { key: "CHECKLIST_BINDING", label: "Binding" },   // direct child — matches sidebar
      {
        key: "CHECKLIST_CONFIG",
        label: "Configuration",
        children: [
          { key: "CHECKLIST_TEMPLATE", label: "Templates" },
        ],
      },
    ],
  },
  {
    key: "QUALITY_PLAN",
    label: "Quality Plan",
    icon: "◎",
    iconBg: "#E1F5EE",
    children: [
      { key: "QUALITY_EXECUTION", label: "Execution" },
      {
        key: "QUALITY_CONFIG",
        label: "Configuration",
        children: [
          { key: "QUALITY_COMPORT", label: "Comport Settings" },
          { key: "QUALITY_DEVICE", label: "Device Settings" },
          { key: "QUALITY_TEMPLATE", label: "Templates" },
        ],
      },
    ],
  },
  {
    key: "AMS",
    label: "Asset Monitoring System",
    icon: "⬡",
    iconBg: "#FAF0E6",
    children: [
      { key: "AMS_LIVE_MONITORING", label: "Live Monitoring" },
      { key: "AMS_NOTIFICATIONS", label: "Notifications" },
    ],
  },
  {
    key: "CONFIGURATION",
    label: "Configuration",
    icon: "⚙",
    iconBg: "#F1EFE8",
    children: [
      { key: "CONFIG_ORGANIZATION", label: "Organization" },
      { key: "CONFIG_PRODUCT", label: "Product" },
      { key: "CONFIG_IOT_GATEWAY", label: "IoT Gateway" },
      { key: "CONFIG_MACHINE", label: "Machine" },
      { key: "CONFIG_ROLE", label: "Role" },
      { key: "CONFIG_USER", label: "User" },
    ],
  },
];

const ACTIONS = ["read", "create", "update", "delete"];

// ─── Helpers ─────────────────────────────────────────────────────────────────

/** Collect every key in the tree recursively */
const collectAllKeys = (nodes) =>
  nodes.flatMap((n) => [n.key, ...(n.children ? collectAllKeys(n.children) : [])]);

/** Build initial flat permissions map from API data */
const buildPermMap = (apiList) => {
  const map = {};
  (apiList || []).forEach(({ menuKey, canRead, canCreate, canUpdate, canDelete }) => {
    map[menuKey] = { read: canRead, create: canCreate, update: canUpdate, delete: canDelete };
  });
  return map;
};

/** Default empty permission object */
const emptyPerm = () => ({ read: false, create: false, update: false, delete: false });

/** Get or create perms for a key */
const getPerms = (map, key) => map[key] || emptyPerm();

/** Cascade: when a parent perm changes, force children to comply */
const cascadeDown = (map, nodes, parentPerms) => {
  let next = { ...map };
  nodes.forEach((node) => {
    const cur = getPerms(next, node.key);
    const effective = {
      read: parentPerms.read && cur.read,
      create: parentPerms.read && parentPerms.create && cur.read && cur.create,
      update: parentPerms.read && parentPerms.update && cur.read && cur.update,
      delete: parentPerms.read && parentPerms.delete && cur.read && cur.delete,
    };
    next[node.key] = effective;
    if (node.children) {
      next = cascadeDown(next, node.children, effective);
    }
  });
  return next;
};

/** Toggle one action on one key */
const togglePerm = (map, nodes, targetKey, action) => {
  let next = { ...map };

  const visit = (nodeList, parentPerms) => {
    nodeList.forEach((node) => {
      if (node.key === targetKey) {
        const cur = getPerms(next, node.key);
        const newVal = !cur[action];
        let updated = { ...cur };

        if (action === "read" && !newVal) {
          updated = emptyPerm(); // turning off read clears everything
        } else {
          updated[action] = newVal;
        }

        next[node.key] = updated;

        // Cascade down to children
        if (node.children) {
          next = cascadeDown(next, node.children, updated);
        }
      } else {
        if (node.children) {
          visit(node.children, getPerms(next, node.key));
        }
      }
    });
  };

  visit(nodes, { read: true, create: true, update: true, delete: true });
  return next;
};

/** Check if a given action toggle should be disabled */
const isDisabled = (permMap, node, action, parentKey) => {
  if (!parentKey) return false;
  const parentPerm = getPerms(permMap, parentKey);
  if (!parentPerm.read) return true;
  if (action !== "read" && !getPerms(permMap, node.key).read) return true;
  return !parentPerm[action];
};

// ─── Toggle component ─────────────────────────────────────────────────────────
const Toggle = ({ on, disabled, onChange }) => (
  <button
    onClick={onChange}
    disabled={disabled}
    style={{
      width: 36,
      height: 20,
      borderRadius: 10,
      border: "none",
      cursor: disabled ? "not-allowed" : "pointer",
      position: "relative",
      background: disabled ? "#EFEFEF" : on ? "#1D9E75" : "#D3D1C7",
      opacity: disabled ? 0.5 : 1,
      transition: "background 0.15s",
      flexShrink: 0,
    }}
  >
    <span
      style={{
        position: "absolute",
        top: 3,
        left: on && !disabled ? 19 : 3,
        width: 14,
        height: 14,
        borderRadius: "50%",
        background: "white",
        transition: "left 0.15s",
        display: "block",
      }}
    />
  </button>
);

// ─── Permission row ───────────────────────────────────────────────────────────
const PermRow = ({ node, permMap, parentKey, onToggle, level }) => {
  const perms = getPerms(permMap, node.key);
  const paddingLeft = 16 + level * 24;

  return (
    <>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 70px 70px 70px 70px",
          alignItems: "center",
          padding: `9px 12px 9px ${paddingLeft}px`,
          borderTop: "0.5px solid #e8e8e8",
          background: level === 0 ? "#fafaf9" : "transparent",
          transition: "background 0.1s",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
          {level > 0 && (
            <span
              style={{
                width: 5,
                height: 5,
                borderRadius: "50%",
                background: "#d0d0d0",
                flexShrink: 0,
              }}
            />
          )}
          <span
            style={{
              fontSize: 13,
              fontWeight: level === 0 ? 500 : 400,
              color: "#1a1a1a",
            }}
          >
            {node.label}
          </span>
        </div>

        {ACTIONS.map((action) => (
          <div key={action} style={{ display: "flex", justifyContent: "center" }}>
            <Toggle
              on={perms[action]}
              disabled={isDisabled(permMap, node, action, parentKey)}
              onChange={() => onToggle(node.key, action)}
            />
          </div>
        ))}
      </div>

      {node.children?.map((child) => (
        <PermRow
          key={child.key}
          node={child}
          permMap={permMap}
          parentKey={node.key}
          onToggle={onToggle}
          level={level + 1}
        />
      ))}
    </>
  );
};

// ─── Module card ──────────────────────────────────────────────────────────────
const ModuleCard = ({ module, permMap, onToggle }) => {
  const [open, setOpen] = useState(false);
  const rootPerm = getPerms(permMap, module.key);
  const activeCount = ACTIONS.filter((a) => rootPerm[a]).length;

  return (
    <div
      style={{
        background: "#ffffff",
        border: "0.5px solid #e5e5e5",
        borderRadius: 10,
        marginBottom: 10,
        overflow: "hidden",
      }}
    >
      {/* Card header — clicking opens the permission rows */}
      <div
        onClick={() => setOpen((v) => !v)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "12px 14px",
          cursor: "pointer",
          background: open ? "#fafaf9" : "#ffffff",
          transition: "background 0.1s",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: 7,
              background: module.iconBg,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 14,
            }}
          >
            {module.icon}
          </div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 500, color: "#1a1a1a" }}>
              {module.label}
            </div>
            <div style={{ fontSize: 11, color: "#999", marginTop: 1 }}>
              {activeCount} of 4 permissions active
            </div>
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {/* Mini badge summary */}
          <div style={{ display: "flex", gap: 5 }}>
            {ACTIONS.map((a) => (
              <span
                key={a}
                style={{
                  fontSize: 10,
                  padding: "2px 7px",
                  borderRadius: 4,
                  fontWeight: 500,
                  background: rootPerm[a] ? "#E1F5EE" : "#F1EFE8",
                  color: rootPerm[a] ? "#0F6E56" : "#888780",
                }}
              >
                {a.charAt(0).toUpperCase() + a.slice(1)}
              </span>
            ))}
          </div>
          <span
            style={{
              fontSize: 13,
              color: "#bbb",
              display: "inline-block",
              transform: open ? "rotate(90deg)" : "rotate(0deg)",
              transition: "transform 0.2s",
            }}
          >
            ›
          </span>
        </div>
      </div>

      {/* Expanded rows */}
      {open && (
        <div style={{ borderTop: "0.5px solid #e8e8e8" }}>
          {/* Column header */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 70px 70px 70px 70px",
              padding: "7px 12px",
              background: "#f5f5f3",
            }}
          >
            <span style={{ fontSize: 11, fontWeight: 500, color: "#bbb", textTransform: "uppercase", letterSpacing: "0.05em" }}>
              Module / Feature
            </span>
            {ACTIONS.map((a) => (
              <span
                key={a}
                style={{
                  fontSize: 11,
                  fontWeight: 500,
                  color: "#bbb",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  textAlign: "center",
                }}
              >
                {a.charAt(0).toUpperCase() + a.slice(1)}
              </span>
            ))}
          </div>

          <PermRow
            node={module}
            permMap={permMap}
            parentKey={null}
            onToggle={onToggle}
            level={0}
          />
        </div>
      )}
    </div>
  );
};

// ─── Main form ────────────────────────────────────────────────────────────────
const UserAccessForm = ({ role, onSaved }) => {
  const [permMap, setPermMap] = useState({});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  // Load existing permissions for this role
  useEffect(() => {
    if (!role?.uuid) return;
    setLoading(true);
    fetchRoleAccess(role.uuid)
      .then((res) => {
        setPermMap(buildPermMap(res.data?.data || []));
      })
      .catch(() => messageApi.error("Failed to load permissions"))
      .finally(() => setLoading(false));
  }, [role?.uuid]);

  const handleToggle = (key, action) => {
    setPermMap((prev) => togglePerm(prev, MENU_TREE, key, action));
  };

  const handleReset = () => {
    const allKeys = collectAllKeys(MENU_TREE);
    const empty = {};
    allKeys.forEach((k) => (empty[k] = emptyPerm()));
    setPermMap(empty);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      // Convert flat permMap back to API shape
      const permissions = Object.entries(permMap).map(([menuKey, p]) => ({
        menuKey,
        canRead: p.read,
        canCreate: p.create,
        canUpdate: p.update,
        canDelete: p.delete,
      }));

      await saveRoleAccess(role.uuid, permissions);
      messageApi.success("Permissions saved successfully");
      setTimeout(() => onSaved?.(), 800);
    } catch {
      messageApi.error("Failed to save permissions");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Spin spinning={loading || saving}>
      {contextHolder}

      {/* Super admin guard — ROLE_SUPER_ADMIN always has full access, nothing to configure */}
      {role?.roleName === "ROLE_SUPER_ADMIN" ? (
        <div style={{
          textAlign: "center", padding: "40px 20px",
          background: "#f6ffed", border: "1px solid #b7eb8f",
          borderRadius: 10, margin: "8px 0",
        }}>
          <div style={{ fontSize: 28, marginBottom: 10 }}>🛡️</div>
          <div style={{ fontWeight: 700, fontSize: 15, color: "#237804", marginBottom: 6 }}>
            Super Admin — Full Access
          </div>
          <div style={{ fontSize: 13, color: "#52c41a", maxWidth: 380, margin: "0 auto" }}>
            Super Admin has unrestricted access to all modules and features.
            Permissions cannot be modified for this role to ensure the system
            always has at least one account that can manage user access.
          </div>
        </div>
      ) : (
        <>
          <div style={{ maxHeight: "65vh", overflowY: "auto", paddingRight: 4 }}>
            {MENU_TREE.map((module) => (
              <ModuleCard
                key={module.key}
                module={module}
                permMap={permMap}
                onToggle={handleToggle}
              />
            ))}
          </div>

          {/* Action bar */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 10,
              marginTop: 16,
              paddingTop: 14,
              borderTop: "0.5px solid #e8e8e8",
            }}
          >
            <button
              onClick={handleReset}
              style={{
                padding: "7px 18px",
                borderRadius: 7,
                fontSize: 13,
                fontWeight: 500,
                cursor: "pointer",
                border: "0.5px solid #ccc",
                background: "#fff",
                color: "#333",
              }}
            >
              Reset
            </button>
            <button
              onClick={handleSave}
              disabled={saving}
              style={{
                padding: "7px 18px",
                borderRadius: 7,
                fontSize: 13,
                fontWeight: 500,
                cursor: saving ? "not-allowed" : "pointer",
                border: "none",
                background: "#1D9E75",
                color: "white",
                opacity: saving ? 0.7 : 1,
              }}
            >
              {saving ? "Saving…" : "Save changes"}
            </button>
          </div>
        </>
      )}
    </Spin>
  );
};

export default UserAccessForm;